<div class="rx-card" [class.read-only]="isReadOnly$ | async">
    <div class="rx-card-title">
        <div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center">
            <div class="rx-card-title-text">{{ 'ScanOptions.ScanOptionsTitle' | translate }}:</div>
        </div>
    </div>
    <div class="rx-card-body" >
        <div
			#NIRICapture
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isNiriCaptureVisible$ | async"
            class="rx-scan-option"
            id="scan-option-niri-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="(isNiriCaptureDisabled$ | async)"
                (changeEvent)="onNiriCaptureUpdate($event.checked)"
                [checked]="isNiriCaptureChecked$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.NIRICapture' | translate }}</tlk-slide-toggle>
        </div>
        <div
			#PalatalScanningFeedback
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isPalatalFeedbackVisible$ | async"
            class="rx-scan-option"
            id="scan-option-palatalFeedback-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="isDisabled$ | async"
                (changeEvent)="onPalatalFeedbackUpdate($event.checked)"
                [checked]="isPalatalFeedbackChecked$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.PalatalScanningFeedback' | translate }}</tlk-slide-toggle>
        </div>
        <div
			#NewSleeveAttached
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isSleeveConfirmationVisible$ | async"
            class="rx-scan-option"
            id="scan-option-sleeve-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="isSleeveConfirmationReadOnly$ | async"
                (changeEvent)="onSleeveConfirmationUpdate($event.checked)"
                [checked]="isSleeveChecked$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.NewSleeveAttached' | translate }}</tlk-slide-toggle>
        </div>
        <div
			#PreTreatmentScan
			[ngStyle]="{'flex': flexProperties}"
			*ngIf="isPreTreatmentVisible$ | async"
            class="rx-scan-option"
            id="scan-option-pre-treatment-toggle-forSonic">
        <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="isPreTreatmentDisabled$ | async"
                (changeEvent)="onPreTreatmentUpdate($event.checked)"
                [checked]="isPreTreatmentChecked$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.PreTreatmentScan' | translate }}</tlk-slide-toggle>
        </div>
        <div
			#DentureCopyScan
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isDentureCopyScanVisible$ | async"
            class="rx-scan-option"
            id="scan-option-dentureCopyScan-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                (changeEvent)="onDentureCopyScanUpdate($event.checked)"
                [checked]="isDentureCopyScan$ | async"
				[isDisabled]="(isDentureCopyScanDisabled$ | async)"
                [class.read-only]="isReadOnly$ | async"
			>{{ 'ScanOptions.DentureCopyScan' | translate }}</tlk-slide-toggle>
        </div>
		<div
			#EmergenceProfile
			[ngStyle]="{'flex': flexProperties}"
			*ngIf="isEmergenceProfileVisible$ | async"
			class="rx-scan-option"
			id="scan-option-emergenceProfile-toggle">
			<tlk-slide-toggle
                class="scan-option-toggle"
					(changeEvent)="onEmergencyProfileUpdate($event.checked)"
					[checked]="isEmergenceProfileChecked$ | async"
					[isDisabled]="(isEmergenceProfileDisabled$ | async)"
					[class.read-only]="isReadOnly$ | async"
			>{{ 'ScanOptions.EmergenceProfile' | translate }}</tlk-slide-toggle>
		</div>
		<div
			#MultiBite
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isMultiBiteVisible"
            class="rx-scan-option"
            id="scan-option-multiBite-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="isDisabled$ | async"
                (changeEvent)="updateScanOptionsMultiBite($event.checked)"
                [checked]="isMultiBiteSelected$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.MultiBite' | translate }}</tlk-slide-toggle>
        </div>
        <div
			#RestoMultiBite
			[ngStyle]="{'flex': flexProperties}"
            *ngIf="isRestoMultiBiteVisible$ | async"
            class="lh-50"
            [ngClass]="{'rx-scan-option': (isRestoMultiBiteSelected$ | async) === false || noLineStyle === false }"
            id="scan-option-restoMultiBite-toggle-forSonic">
            <tlk-slide-toggle
                class="scan-option-toggle"
                [isDisabled]="isDisabled$ | async"
                (changeEvent)="updateScanOptionsRestoMultiBite($event.checked)"
                [checked]="isRestoMultiBiteSelected$ | async"
                [class.read-only]="isReadOnly$ | async"
            >{{ 'ScanOptions.MultiBite' | translate }}</tlk-slide-toggle>
        </div>
        <div
            #AdditionalBites
            *ngIf="(isAdditionalBitesVisible$ | async)"
            id="additional-bites"
            class="additional-bites">
            <div class="additional-bite" *ngFor="let bite of additionalBites" [class.active]="isBiteSelected(bite.id) | async"  [id]= "bite.textKey.toLowerCase()">
                <img [src]="'assets/bites' + '/' + bite.img + '.svg' | staticFilesEndpoint" class="bite-img additional-bite-item" alt="checked"/>
                <span class="additional-bite-item">{{ 'RestoMultiBite.' + bite.textKey | translate }}</span>
                <tlk-checkbox
                    class="pre-treatment-checkbox additional-bite-item"
                    [isDisabled]="isDisabled$ | async"
                    [checked]="isBiteSelected(bite.id) | async"
                    (changeEvent)="onAdditionalBitesUpdate($event.checked, bite.id)"
                    [class.read-only]="isReadOnly$ | async"
                />
            </div>
        </div>
    </div>
    <rx-banner [type]="'notification'" *ngIf="(shouldShowMultiBiteInformationMessage$ | async)"
               [message]="'ScanOptions.MultiBiteInformationMessage' | translate"
               class="bottom-banner"
    ></rx-banner>
</div>
